export default "/_next/static/chunks/fonts/HK Grotesk Semi Bold-f7d9b313db94b189070b5d4c62d51053.otf";